export default __webpack_public_path__ + "static/logo-269d9f0877e9a4ad5bec8c4488657f30.gif";